export default __webpack_public_path__ + "static/jedi-bee-6d889087b184addd2f6966db0e8c39b8.png";